const initialState = {
  avaliableTag: []
}
export const tagsInputReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}
